


































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { dictServe, doublePrevention } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component
export default class PublicProp extends Vue {
  visible = false;
  dialogVisible = false;
  private fileUrlLoad: any = '';
  pathFile: any = '';
  canEdit = false;
  title = '';
  formData: any = {
    annex: [], // 附件
    receiptScanAnnex: [], // 回执扫描件
    name: '', // 预案名称
    location: '', // 演练地点
    nextReviseDate: '', // 下次修订日期
    putOnRecordCode: '', // 备案编号
    putOnRecordTime: '', // 备案时间
    putOnRecordUnit: '', // 备案单位
    isPutOnRecord: null, // 是否备案登记
    putOnRecordExpireDate: '', // 备案到期时间
    releaseDocumentNumber: '', // 发布文号
    reportTime: '', // 上报时间
    reviseDate: '', // 修订日期
    signer: '', // 签发人
    type: '', // 预案类型
    classify: '', // 预案类型
    classifyLabel: '', // 预案类型
    establishmentReviseExplanation: '', // 编制或修订说明
  };
  typeList: any = []; // 演练方式
  classifyList: any = []; // 分类

  ruleForm: any = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' },
    ],
    annex: [{ required: true, validator: this.annexValidate, trigger: 'blur' }],
  };
  private async annexValidate(rule: any, value: any, callback: any) {
    if (!this.fileList.length) {
      callback(new Error('请上传附件'));
    }
    callback();
  }

  classifyChange(e: any) {
    if (e) {
      this.formData.classifyLabel = this.classifyList.filter((item: any) => item.value === e)[0].label;
    } else {
      this.formData.classifyLabel = '';
    }
  }

  showDialog(data: any) {
    this.fileUrlLoad = publishObjectPath.imgPathWater;
    this.headers.Authorization = localStorage.getItem('token');
    // console.log(this.headers);
    this.getTypeList('emergencyPlanType'); // 获取演练方式的下拉
    this.getTypeList('emergencyPlan-classify'); // 获取演练方式的下拉
    switch (data.type) {
      case 'add':
        this.title = '添加预案';
        this.canEdit = false;
        break;
      case 'detail':
        this.title = '预案详情';
        this.canEdit = true;
        this.getDetail(data.data.id);
        break;
      case 'edit':
        this.title = '编辑预案';
        this.canEdit = false;
        this.getDetail(data.data.id);
        break;
      default:
        this.title = '';
    }
    this.visible = true;
  }

  /* 预案类型 的下拉 */
  getTypeList(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'emergencyPlanType') {
          this.typeList = helpArr;
        } else if (name === 'emergencyPlan-classify') {
          this.classifyList = helpArr;
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  hideDialog() {
    this.visible = false;
    this.formData = {};
    this.$emit('getTableData');
    this.fileList = [];
    this.fileList1 = [];
    this.formData.annex = [];
    this.formData.receiptScanAnnex = [];
    (this.$refs.form as any).clearValidate();
  }

  submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        if (this.title === '添加预案') this.addEmergencyDrillRecord();
        if (this.title === '编辑预案') this.editEmergencyDrillRecord();
      } else {
        return false;
      }
    });
  }

  /* 新增的接口 */
  addEmergencyDrillRecord() {
    console.log(this.formData);
    doublePrevention
      .addEmergencyPlan({
        ...this.formData,
        annex: this.formData.annex !== [] ? this.formData.annex.toString() : '',
        receiptScanAnnex: this.formData.receiptScanAnnex !== [] ? this.formData.receiptScanAnnex.toString() : '',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 编辑的接口 */
  editEmergencyDrillRecord() {
    doublePrevention
      .editEmergencyPlan({
        ...this.formData,
        annex: this.formData.annex !== [] ? this.formData.annex.toString() : '',
        receiptScanAnnex: this.formData.receiptScanAnnex !== [] ? this.formData.receiptScanAnnex.toString() : '',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功编辑该条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 详情的接口 */
  getDetail(id: any) {
    doublePrevention.getSingleEmergencyPlan(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.fileList = res.data.annexList;
        this.fileList1 = res.data.receiptScanAnnexList;
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  /* 导入用到的 */
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
  private headers: any = {};
  private fileList: any = [];
  private fileList1: any = [];
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
    const helpArr: any = [];
    this.fileList.forEach((item: any) => {
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.annex = helpArr;
    (this.$refs['form'] as any).validateField(['annex']);
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'GIF' || suffix === 'SVG' || suffix === 'PDF' || suffix === 'TXT' || suffix === 'DOC' || suffix === 'DOCX' || suffix === 'XLSX' || suffix === 'XLS' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'gif' || suffix === 'svg' || suffix === 'pdf' || suffix === 'txt' || suffix === 'doc' || suffix === 'docx' || suffix === 'xlsx' || suffix === 'xls') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP,GIF,SVG,PDF,TXT,DOC,DOCX,XLSX,XLS！');
      return false;
    }
  }

  private handlePreview(file: any) {
    // console.log(file);
    this.dialogVisible = true;
    if (file.response) {
      this.pathFile = this.fileUrlLoad + file.response.data[0].path;
    } else {
      this.pathFile = this.fileUrlLoad + file.path;
    }
  }

  private handleAvatarCardFrontSuccess(response: any, file: any, fileList: any) {
    this.fileList = fileList;
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.annex = arr;
    (this.$refs['form'] as any).validateField(['annex']);
  }
  private handleRemove1(file: any, fileList: any) {
    this.fileList1 = fileList;
    const helpArr: any = [];
    this.fileList1.forEach((item: any) => {
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.receiptScanAnnex = helpArr;
  }
  private handleAvatarCardFrontSuccess1(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.receiptScanAnnex = arr;
  }

  private beforeClose() {
    this.dialogVisible = false;
  }
}
